<template>
  <div class="price-filter filter-form">
    <span id="tooltip" class="range-label text-center">
      {{ label }}
    </span>

    <p class="range-values-container">
      <span>{{ origMin|currency }}</span>
      <span>{{ origMax|currency }}</span>
    </p>

    <vue-slider v-model="selected" :min="origMin" :max="origMax"
                :enable-cross="false"
                :tooltip-formatter="formatCurrency"
                tooltip-placement="bottom"
                :tooltip-style="{ 'background-color': '#e65011','border-color':'#e65011' }"
                :process-style="{ 'background-color': '#e65011' }"
                :rail-style="{ 'background-color': '#1A2050' , 'height':'2px' }"
                :dot-style="{ 'background-color': '#e65011','border-color':'#e65011'}"
    />

    <p class="text-right">
      <b-button class="btn-as-link" @click="reset">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
import filtersMixin from '@/components/frontoffice/Booking/filters/mixin'
import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  components: {
    vueSlider
  },

  mixins: [filtersMixin],

  props: {
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 1000
    },
    origMin: {
      type: [Number, String],
      default: 0
    },
    origMax: {
      type: [Number, String],
      default: 1000
    }
  },

  data () {
    return {
      selected: []
    }
  },

  // created () {
  //   this.reset()
  // },

  mounted () {
    this.selected = this.initSelected ? [Math.floor(this.initSelected.min), Math.ceil(this.initSelected.max)] : [Math.floor(this.origMin), Math.ceil(this.origMax)]
  },

  methods: {
    reset () {
      this.selected = [Math.floor(this.origMin), Math.ceil(this.origMax)]
      if (this.hasInit) this.emitChanges()

      this.hasInit = true
    },

    formatCurrency (value) {
      if (value < this.min) value = this.min
      if (value > this.max) value = this.max

      return this.$options.filters.currency(value)
    },

    emitChanges () {
      this.$emit('update', {
        name: this.name,
        value: {
          min: this.getMin,
          max: this.getMax
        }
      })
    }
  },

  computed: {
    label () {
      if (this.getMin !== this.getMax) {
        return `
          ${this.$t('_between')}
          ${this.$options.filters.currency(this.getMin)}
          ${this.$t('_and')}
          ${this.$options.filters.currency(this.getMax)}`
      } else return this.$options.filters.currency(this.getMin)
    },

    getMin () {
      return this.selected[0]
    },

    getMax () {
      return this.selected[1]
    }
  },

  watch: {
    selected () {
      this.emitChanges()
    }
  }
}
</script>
